import * as d3 from 'd3'
import * as d3Annotations from 'd3-svg-annotation'

const d3Obj = { ...d3, ...d3Annotations }

export default d3Obj
